export const CLIENT_BOOKING_SEARCH_ENTRYPOINT: string = 'client_booking_search_entrypoint_20210429';
export const CLIENT_BOOKING_SEARCH_ENTRYPOINT_SOURCE: string = 'booking_availability';
export const CLIENT_BOOKING_SEARCH_ENTRYPOINT_HAS_SEEN_TOASTER_KEY: string = `${CLIENT_BOOKING_SEARCH_ENTRYPOINT}__has_seen_toaster`;
export const CLIENT_BOOKING_APPLY_DISCOUNT_FLAG = 'client_booking_apply_discount_amp155_20211014';
